import { render, staticRenderFns } from "./MenuItemText.vue?vue&type=template&id=1f2f7598&"
import script from "./MenuItemText.vue?vue&type=script&lang=js&"
export * from "./MenuItemText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports